import { styled, useTheme } from 'styled-components'
import { TextWidth, ContentWidth } from '@ta-interaktiv/react-disco-grid'

const Ai2HtmlImage = ({imageSrc, imageAlt, imageLegend}: {imageSrc: string, imageAlt: string, imageLegend: string}) => {
  const theme = useTheme()
  const darkSuffix = theme.colorMode === 'dark' ? '-dark' : ''


  return (
    <Container>
      <TextWidth>
        <Image src={imageSrc} alt={imageAlt} />
        <Source>Source: {imageLegend}</Source>
      </TextWidth>
    </Container>
  )
}

const Container = styled.div``

const Image = styled.img`
  width: 100%;
  height: auto;
  display: block;
  margin: 0 auto;
`

const Source = styled.div`
  font-size: 0.65em;
  line-height: 1.3em;
`

export default Ai2HtmlImage
